export const DBURL='https://rentalsdb.onrender.com/bookings'

export const LocalUrl='https://nmrentalservice.onrender.com/'
export const Local='https://nmrentalservice.onrender.com/'
//export const Local='http://localhost:4000/'
